module.exports = __webpack_public_path__ + "static/img/lucky_draw_banner_zh@2x.1fd8244.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/greenchannel/lucky_draw_banner_zh@2x.png
// module id = vQ6K
// module chunks = 1